module.exports = __webpack_public_path__ + "img/logo-white.ef5a9b83.png";